import React from 'react';
import LabsNav from '@/components/labs/LabsNav';
import LabsHero from '@/components/labs/LabsHero';
import LabsAdvantages from '@/components/labs/LabsAdvantages';
import LabsVerticals from '@/components/labs/LabsVerticals';
import BuilderSection from '@/components/labs/BuilderSection';
import StatsBar from '@/components/labs/StatsBar';
import ProductCard from '@/components/labs/ProductCard';
import MidCTA from '@/components/labs/MidCTA';
import PortfolioSummary from '@/components/labs/PortfolioSummary';
import LabsFooter from '@/components/labs/LabsFooter';
import { products } from '@/data/labsProducts';

const NoaLabsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white">
      <LabsNav />
      <LabsHero />
      <LabsAdvantages />
      <LabsVerticals />
      <BuilderSection />
      <StatsBar />

      {/* Products */}
      <section id="products" className="relative py-24 px-6 sm:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="mb-16">
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#3B82F6]/50 mb-3 block">Auto AI</span>
            <h2 className="font-space-grotesk text-3xl sm:text-4xl font-bold text-white mb-3">
              8 Product Verticals
            </h2>
            <p className="text-[#A1A1AA]/50 text-sm max-w-md">
              Each vertical is a standalone business opportunity within Noa Labs.
            </p>
          </div>

          <div className="space-y-6">
            {products.slice(0, 4).map((product, i) => (
              <ProductCard key={product.id} product={product} index={i} />
            ))}
          </div>

          <MidCTA />

          <div className="space-y-6">
            {products.slice(4).map((product, i) => (
              <ProductCard key={product.id} product={product} index={i + 4} />
            ))}
          </div>
        </div>
      </section>

      <PortfolioSummary />
      <LabsFooter />
    </div>
  );
};

export default NoaLabsPage;
